import { render, staticRenderFns } from "./GAuthTextareaField.vue?vue&type=template&id=045b690e&scoped=true&"
import script from "./GAuthTextareaField.vue?vue&type=script&lang=ts&"
export * from "./GAuthTextareaField.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthTextareaField.vue?vue&type=style&index=0&id=045b690e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b690e",
  null
  
)

export default component.exports